import React, { Fragment } from 'react';
import { Button, Modal } from 'antd';
import { connect } from 'react-redux';
import HpiCheckModal from '../../Lead_profile/components/Modals/HpiCheckModal';
import { getBikeHpiCheckRequest } from '../../Lead_profile/redux/actions/bike_hpi_check.actions';


class HpiCheckApproval extends React.Component {
    state = {
        hpiCheckDetailsVisible: false,
    };

    openHpiCheckDetails = () => {
        this.setState(
            {
                hpiCheckDetailsVisible: true,
            },
            () => this.props.getBikeHpiCheckRequest(this.props.bike_id),
        );
    };

    closeHpiCheckDetails = (e) => {
        this.setState({
            hpiCheckDetailsVisible: false,
        });
    };

    render() {
        return (
            <Fragment>
                <Button onClick={this.openHpiCheckDetails}>Open HPI Check details</Button>

                <Modal
                    title="HPI check details"
                    footer={null}
                    width={1100}
                    visible={this.state.hpiCheckDetailsVisible}
                    onOk={this.openHpiCheckDetails}
                    onCancel={this.closeHpiCheckDetails}
                >
                    <HpiCheckModal isHpiCheckApproval bike_id={this.props.bike_id} hideRerunHpiCheckForApproval />
                </Modal>
            </Fragment>
        );
    }
}

export default connect(null, { getBikeHpiCheckRequest })(HpiCheckApproval);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/components/HpiCheckApproval.js